import React, { lazy, Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import DtcLeadConfirmationDev from './confirmation/DtcLeadConfirmationDev';
import ReferLeadConfirmationDev from './confirmation/ReferLeadConfirmationDev';
import { LeadProgram } from './constants';

const LeadReferPage = lazy(() => import('app-pages/pages/leads/LeadReferPage'));

const LeadDtcSignUpPage = lazy(
  () => import('app-pages/pages/leads/LeadDtcSignupPage'),
);

export default function LeadsRouter({
  fromAspSubdomain,
  fromNPSubdomain,
  fromReferSubdomain,
}: {
  fromReferSubdomain: boolean;
  fromAspSubdomain: boolean;
  fromNPSubdomain: boolean;
}) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isMedicaid = queryParams.get('isMedicaid') == 'true';
  const leadInfo = {
    email: queryParams.get('email') || 'test@bendhealthtest.com',
    first_name: queryParams.get('first_name') || 'first_name',
    last_name: queryParams.get('last_name') || 'last_name',
    phone_number: queryParams.get('phone_number') || 'phone_number',
  };

  const program = fromAspSubdomain
    ? LeadProgram.ASP
    : fromNPSubdomain
      ? LeadProgram.NP
      : undefined;
  return (
    <Routes>
      {program && (
        <React.Fragment>
          <Route
            path="/signup"
            element={
              <Suspense>
                <LeadDtcSignUpPage program={program} />
              </Suspense>
            }
          />

          <Route
            path="/partner/:partner_name?"
            element={
              <Suspense>
                <LeadReferPage program={program} />
              </Suspense>
            }
          />

          {/* Route for testing without the backend */}
          <Route
            path="/confirmation"
            element={
              <DtcLeadConfirmationDev
                program={program}
                isMedicaid={isMedicaid}
                leadInfo={leadInfo}
              />
            }
          />
        </React.Fragment>
      )}

      {fromReferSubdomain && (
        <React.Fragment>
          <Route
            path="/asp"
            element={
              <Suspense>
                <LeadReferPage program={LeadProgram.ASP} />
              </Suspense>
            }
          />
          <Route
            path="/asp/partner/:partnerName?"
            element={
              <Suspense>
                <LeadReferPage program={LeadProgram.ASP} />
              </Suspense>
            }
          />
          <Route
            path="/behavioral"
            element={
              <Suspense>
                <LeadReferPage program={LeadProgram.CC} />
              </Suspense>
            }
          />
          <Route
            path="/behavioral/partner/:partnerName?"
            element={
              <Suspense>
                <LeadReferPage program={LeadProgram.CC} />
              </Suspense>
            }
          />
          <Route path="/np">
            <Route
              index
              element={
                <Suspense>
                  <LeadReferPage program={LeadProgram.NP} />
                </Suspense>
              }
            />
            <Route
              path="partner/:partnerName?"
              element={
                <Suspense>
                  <LeadReferPage program={LeadProgram.NP} />
                </Suspense>
              }
            />
          </Route>

          {/* Route for testing without the backend */}
          <Route
            path="/:program/confirmation"
            element={
              <ReferLeadConfirmationDev
                isMedicaid={isMedicaid}
                leadInfo={leadInfo}
              />
            }
          />
        </React.Fragment>
      )}
    </Routes>
  );
}
